import * as React from "react";
import type { SVGProps } from "react";
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.354 5.646a.5.5 0 1 0-.708.708l5.607 5.606-5.607 5.606a.5.5 0 0 0 .708.708l5.606-5.607 5.606 5.607a.5.5 0 0 0 .708-.708l-5.607-5.606 5.607-5.606a.5.5 0 0 0-.708-.708l-5.606 5.607z"
    />
  </svg>
);
export default SvgClose;
